export enum WebMessageType {
  LOGOUT = 'logout',
  LOGIN = 'login',
  CREDENTIALS = 'credentials',
  REQUEST_LOCATION = 'request_location',
}

export type WebMessageData = string

export interface WebMessage {
  type: WebMessageType
  data?: WebMessageData
}
